// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4cb1239f","239":"45407b3a","455":"e8c620c7"}[chunkId] + ".chunk.js";
};